import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { debounce } from './utilities'

gsap.registerPlugin(ScrollTrigger)

export const initServices = () => {
	const services = document.querySelector('.services')

	if (window.innerWidth < 1200 || !services) return 

	function animateHeadings() {
		let items = services.querySelectorAll('.services__item'),
			titles = services.querySelectorAll('.services__title--desktop')

		titles.forEach((title, index) => {
			const lines = title.querySelectorAll('.line')
			if (index === 0) {
				gsap.set(lines, {
					rotate: 0,
					y: '0%',
				})
			} else {
				gsap.set(lines, {
					rotate: '6deg',
					y: '105%',
				})
			}
		})

		titles.forEach((title, index) => {
			const lines = title.querySelectorAll('.line')
			const currentItem = items[index]
			const nextItem = items[index + 1]
			const isLastTitle = index === titles.length - 1

			if (!currentItem) return

			if (index === 0) {
				gsap.timeline({
					scrollTrigger: {
						trigger: items[1],
						start: 'top 60%',
						end: 'top 42%',
						scrub: true,
						onUpdate: (self) => {
							const progress = self.progress
							gsap.set(lines, {
								rotate: gsap.utils.interpolate(0, -6, progress),
								y: gsap.utils.interpolate(0, -105, progress) + '%',
							})
						}
					}
				})
				return
			}

			if (isLastTitle) {
				gsap.timeline({
					scrollTrigger: {
						trigger: currentItem,
						start: 'top 60%',
						end: 'center center',
						scrub: true,
						onUpdate: (self) => {
							const progress = self.progress
							gsap.set(lines, {
								rotate: gsap.utils.interpolate(6, 0, progress),
								y: gsap.utils.interpolate(105, 0, progress) + '%',
							})
						}
					}
				})
				return
			}

			gsap.timeline({
				scrollTrigger: {
					trigger: currentItem,
					start: 'top 60%',
					end: 'bottom 30%',
					scrub: true,
					onUpdate: (self) => {
						const progress = self.progress
						
						if (progress < 0.3) {
							const localProgress = progress / 0.3 // 0 to 1
							gsap.set(lines, {
								rotate: gsap.utils.interpolate(6, 0, localProgress),
								y: gsap.utils.interpolate(105, 0, localProgress) + '%',
							})
						} else if (progress >= 0.3 && progress <= 0.7) {
							gsap.set(lines, {
								rotate: 0,
								y: '0%',
							})
						} else {
							const localProgress = (progress - 0.7) / 0.3 // 0 to 1
							gsap.set(lines, {
								rotate: gsap.utils.interpolate(0, -6, localProgress),
								y: gsap.utils.interpolate(0, -105, localProgress) + '%',
							})
						}
					}
				}
			})
		})
	}

	const resetAnimation = () => {
		ScrollTrigger.getAll().forEach(trigger => trigger.kill())
		
		const titles = services.querySelectorAll('.services__title--desktop')
		titles.forEach((title, index) => {
			const lines = title.querySelectorAll('.line')
			if (index === 0) {
				gsap.set(lines, {
					rotate: 0,
					y: '0%',
				})
			} else {
				gsap.set(lines, {
					rotate: '6deg',
					y: '105%',
				})
			}
		})
		
		animateHeadings()
	}

	animateHeadings()

	let windowWidth = window.innerWidth

	const handleResize = () => {
		if (windowWidth != window.innerWidth) {
			resetAnimation()
			windowWidth = window.innerWidth
		}
	}

	const debouncedResize = debounce(handleResize, 300)
	window.addEventListener('resize', debouncedResize)
}

export default () => { } 